import React from 'react';
import { mockData } from '../utils/mock';
import { useLanguage } from '../context/LanguageContext';
import { Reveal } from './decor';

const About = ({ onOpenGallery }) => {
  const { t, language } = useLanguage();
  const { about } = mockData;
  const content = about[language] || about.es;

  return (
    <section id="about" style={{ background: '#EFEADD', padding: '100px 0' }} data-testid="about-section">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-[60px]">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Text */}
          <Reveal>
            <div className="flex items-center" style={{ gap: '14px' }}>
              <span style={{ display: 'block', width: '32px', height: '1px', background: '#9A7522' }} />
              <span className="font-body uppercase" style={{ fontSize: '11px', letterSpacing: '3px', color: '#9A7522', fontWeight: 500 }}>
                {t('nav.nosotros')}
              </span>
            </div>
            <h2 className="font-display mt-5" style={{ fontSize: 'clamp(34px, 5vw, 52px)', fontWeight: 700, color: '#161616', lineHeight: 1.1 }}>
              {content.title}
            </h2>
            <p className="font-body mt-3" style={{ fontSize: '15px', fontStyle: 'italic', color: '#9A7522' }}>
              {content.subtitle}
            </p>

            <div className="mt-7 space-y-5">
              <p className="font-body" style={{ fontSize: '15px', fontWeight: 400, color: '#1E1E1A', lineHeight: 1.9 }}>
                {content.description}
              </p>
              <p className="font-body" style={{ fontSize: '15px', fontWeight: 300, color: '#5C5C54', lineHeight: 1.9 }}>
                {content.description2}
              </p>
              <p className="font-body" style={{ fontSize: '15px', fontWeight: 300, color: '#5C5C54', lineHeight: 1.9 }}>
                {content.description3} {content.description4}
              </p>
            </div>

            <button
              onClick={onOpenGallery}
              className="font-body uppercase mt-9 inline-flex items-center transition-colors duration-200 group"
              style={{ border: '1px solid #9A7522', color: '#6E5518', padding: '13px 28px', fontSize: '12px', letterSpacing: '2px', fontWeight: 600 }}
              onMouseEnter={(e) => { e.currentTarget.style.background = '#9A7522'; e.currentTarget.style.color = '#EFEADD'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#6E5518'; }}
              data-testid="about-learn-more"
            >
              {t('aboutBtn')}
              <span className="ml-2 transition-transform duration-200 group-hover:translate-x-1">→</span>
            </button>
          </Reveal>

          {/* Image */}
          <Reveal delay={0.15}>
            <div className="relative mb-8 lg:mb-0" style={{ padding: '12px' }}>
              <div className="absolute" style={{ inset: 0, border: '1px solid rgba(154,117,34,0.4)' }} />
              <div className="relative overflow-hidden">
                <img
                  src={about.image}
                  alt="Yamauchi Ramen"
                  className="w-full object-cover h-[360px] sm:h-[460px] lg:h-[560px]"
                  style={{ filter: 'brightness(0.85) saturate(0.9)', objectPosition: 'center' }}
                />
              </div>
              {/* Floating tag */}
              <div
                className="absolute flex flex-col bottom-[-16px] left-2 lg:bottom-[-24px] lg:left-[-24px]"
                style={{ background: '#C8282B', padding: '12px 18px' }}
                data-testid="about-floating-tag"
              >
                <span className="font-bebas text-white" style={{ fontSize: '34px', lineHeight: 0.9 }}>山内</span>
                <span className="font-body uppercase text-white" style={{ fontSize: '10px', letterSpacing: '2px', opacity: 0.85 }}>
                  Cayey · Puerto Rico
                </span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
